import {
  PublicClientApplication
} from '@azure/msal-browser'

export const msalConfig = {
  auth: {
    clientId: azureConfig.VUE_APP_AD_CLINET_ID,
    authority: azureConfig.VUE_APP_AD_POLICY_AUTHORITY + '/B2C_1_signupsignin1',
    redirectUri: azureConfig.VUE_APP_AD_REDIRECT_URI,
    postLogoutRedirectUrl: 'http://localhost:8080/logout',
    validateAuthority: false,
    knownAuthorities: [azureConfig.VUE_APP_AD_POLICY_AUTHORITY],
    scopes: [
      ...azureConfig.VUE_APP_AD_B2CSCOPES,
      'offline_access',
      'openid',
      'profile',
    ],
    mode: 'redirect',
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false,
  },
}
export const msalInstance = new PublicClientApplication(msalConfig)

/**
 * Clears the MSAL interaction-in-progress lock from sessionStorage and calls logoutRedirect.
 * The lock can be left behind when a previous redirect flow didn't complete cleanly,
 * causing a BrowserAuthError: interaction_in_progress on the next interactive call.
 */
export async function safeLogoutRedirect(logoutRequest = {}) {
  // MSAL 2.x stores the lock as "<clientId>.interaction.status" in sessionStorage
  const interactionKey = Object.keys(sessionStorage).find(
    key => key.endsWith('.interaction.status')
  )
  if (interactionKey) {
    sessionStorage.removeItem(interactionKey)
  }
  return msalInstance.logoutRedirect(logoutRequest)
}
